import type { FC, ReactNode } from 'react';
import React from 'react';
import { css } from '@compiled/react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';

import EmptyStateImageLight from './images/empty/EmptyStateImageLight.svg';

const emptyContainerStyles = css({
	marginTop: token('space.800'),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

const emptyHeaderStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '35px',
});

const emptyBodyStyles = css({
	marginTop: token('space.200'),
	width: '395px',
	textAlign: 'center',
});

const callToActionStyles = css({
	marginTop: token('space.200'),
});

export type EmptyImageSources = {
	src: any;
	srcDark?: any;
};

type EmptyType = {
	header: MessageDescriptor;
	body: MessageDescriptor;
	image?: EmptyImageSources;
	callToAction?: ReactNode;
};

const emptyStateImage: EmptyImageSources = {
	src: EmptyStateImageLight,
};

export const Empty: FC<EmptyType> = ({ header, body, image = emptyStateImage, callToAction }) => (
	<div css={emptyContainerStyles}>
		<Image src={image.src} srcDark={image.srcDark} alt="" />
		{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
		<h3 css={emptyHeaderStyles}>
			<FormattedMessage {...header} />
		</h3>
		<div css={emptyBodyStyles}>
			<FormattedMessage
				{...body}
				values={{
					strong: (...chunks: React.ReactNode[]) => <Text as="strong">{chunks}</Text>,
				}}
			/>
		</div>
		{callToAction && <div css={callToActionStyles}>{callToAction}</div>}
	</div>
);
